<template>
  <VSalesRevenueTable />
</template>
<script>
import VSalesRevenueTable from '@/components/SalesRevenue/VSalesRevenueTable'
export default {
  name: 'SalesRevenue',
  
  components: {
    VSalesRevenueTable
  }
}
</script>
